module.exports = __webpack_public_path__ + "img/huangguan.1165fa90.jpg";